// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__xVtjA","modal":"logo_modal__nsxa5","modal-dialog":"logo_modal-dialog__WEJnT","btn":"logo_btn__SMwtC","title":"logo_title__TTfjz"};